export default __webpack_public_path__ + "static/media/promoIcon.0b783758.svg";